import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { Store } from '@ngrx/store';
import { AppState } from '../app.state';

import { KioskAppointment } from './kiosk.model';
import { State as KioskState } from './kiosk.reducer';

import { objectToHttpParams, snakeizeParams } from '../util';

export interface IAppointmentsByHinParams {
  readonly groupId: number
  readonly hin: string;
}

export interface IUpdateArrivalStatusParams {
  readonly subscriptionId: number;
  readonly appointmentIds: number[];
  readonly hin: string;
}

export interface IUpdateContactInfoStatusParams {
  readonly subscriptionId: number;
  readonly appointmentIds: number[];
  readonly hin: string;
  readonly upToDate?: boolean;
}

@Injectable()
export class KioskService {
  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
  ) {}

  getAppointmentsByHin({ groupId, hin }: IAppointmentsByHinParams): Observable<KioskState> {
    return this.http.get<KioskState>(`/api/v2/groups/${groupId}/arrival_kiosk/appointments`, { params: objectToHttpParams({ hin }) });
  }

  updateArrivalStatus(groupId, params: IUpdateArrivalStatusParams): Observable<any> {
    return this.http.post<KioskState>(`/api/v2/groups/${groupId}/arrival_kiosk/appointment_arrival_statuses`, objectToHttpParams(snakeizeParams(params))); 
  }

  updateContactInfoStatus(groupId, params: IUpdateContactInfoStatusParams): Observable<any> {
    return this.http.post<KioskState>(`/api/v2/groups/${groupId}/arrival_kiosk/contact_info_status`, objectToHttpParams(snakeizeParams(params))); 
  }  
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/kiosk/kiosk.service.ts